import Vue from "vue";
import Vuex from "vuex";
import AppState from "@/service/app-state.js"

Vue.use(Vuex);

export default new Vuex.Store(AppState);
